// The frame of the administrator's pages: the side menu with how many wait, and what every page of theirs needs.

import { ApiFailure } from './api.ts';
import { topbar } from './layout.ts';
import { openContentsSubmit } from './submit.ts';
import { must, onAct } from './util.ts';

export type Section = 'queue' | 'subs' | 'items' | 'cats';

export const failed = (thrown: unknown, fallback = '出了点问题，请稍后再试。'): string => (thrown instanceof ApiFailure ? thrown.message : fallback);

/** The frame: the side menu with how many wait, and the page's own content. */
export function shell(app: HTMLElement, active: Section, openCount: number, body: string): HTMLElement {
  const link = (section: Section, href: string, label: string, badge = '') => `<a href="${href}" class="${active === section ? 'on' : ''}">${label}${badge}</a>`;
  app.innerHTML = `${topbar('admin')}<div class="admin"><aside class="side"><div class="side-title">管理员</div>
    ${link('queue', '#/admin', '待处理', `<span class="badge" id="open-badge" style="${openCount ? '' : 'display:none'}">${openCount}</span>`)}
    ${link('subs', '#/admin/submissions', '全部提交')}${link('items', '#/admin/items', '内容管理')}${link('cats', '#/admin/categories', '分类')}
    <div class="foot"><a href="#" data-act="logout">退出登录</a></div></aside><main>${body}</main></div>`;
  return must('main', app);
}

export const addButtons = `<div class="actions-row"><button class="btn" data-act="admin-add">添加内容</button></div>`;
onAct('admin-add', () => openContentsSubmit('admin'));
onAct('goto', (element) => {
  location.hash = element.dataset.href ?? '#/admin';
});
